export const getInitialState = (): any => ({
  snowflakePushDataToAzureData: {},
  snowflakePushDataToAzureStatus: 0
});